{
    "customerUI": {
        "searchResultsPath": "/cui/search",
        "sumarryPath": "/cui/overview",
        "nonProd": "https://ete-customer.libertymutual.com",
        "prod": "https://customer-agent.libertymutual.com"
    },
    "claimsUI": {
        "summaryPath": "/claimsui/detail",
        "nonProd": "https://ete-claims.safeco.com",
        "prod": "https://claims.safeco.com"
    },
    "settings": {
        "nonProd": "https://ete-settings.libertymutual.com/Settings/dist/",
        "prod": "https://settings.libertymutual.com/Settings/dist/index.html"
    }
}